import { useMemo } from 'react';
import { isUngated } from 'products-ui-components/utils/isUngated';
import useUserInfo from './useUserInfo';
export function useIsUngated(gate) {
  const userInfo = useUserInfo();
  return useMemo(() => {
    return isUngated(userInfo, gate);
  }, [userInfo, gate]);
}